import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonForm from 'components/commonForm/CommonForm';

export default function CommonDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const handleClose = () => {
    props.handleClose();
    if(props?.toggle){
    props?.toggle()}
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        sx={{
          '& .MuiDialog-paper': props.formName ==='couponForm' ? {
            width: '1200px',
            maxWidth: '1200px',
          } : {}
        }}
      >
        <DialogTitle id="responsive-dialog-title" className='modelMain'>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="modelCloseIcon"
          >
            <CloseIcon />
          </IconButton>
          <Grid container>
            <Grid item xs={12} className="dialogHead">
              {props.selectType === 'Send' ? (
                <Typography>
                  {props.selectType === 'Send' ? props.type : ''}
                </Typography>
              ) : props.selectType === 'edit' ? (
                <Typography className="titleStyle">
                  {props?.type?.split(' ').slice(0, 1)}{' '}
                  <span className="colorSecondary">
                    {props?.type?.split(' ').slice(1).join(' ')}
                  </span>
                </Typography>
              ) : props.selectType === 'create' ? (
                <Typography className="titleStyle">
                  {'Add '}
                  <span className="colorSecondary">{props.type}</span>
                </Typography>
              ) : props.selectType === 'copy' ? (
                <Typography className="titleStyle">
                  {'Add '}
                  <span className="colorSecondary">{props.type}</span>
                </Typography>
              ) : props.selectType === 'vendorAdd' ? (
                <Typography className="titleStyle">
                  {'Enter '} {props.type}
                  <span className="colorSecondary">{' Details'}</span>
                </Typography>
              ): props.selectType === 'delete' ? (
                <Typography className="titleStyle">
                  {'Delete '} 
                  {/* <span className="colorSecondary">{' Coupon'}</span> */}
                  <span className="colorSecondary">{props.typeOfDialog}</span>
                </Typography>
              ): null}
            </Grid>
          </Grid>
        </DialogTitle>
        {props?.text ? <p className='colorBlack px-4 text-center'>{props?.text}</p> : null}
        <DialogContent>
          <DialogContentText>
            <Grid container>
              <Grid item xs={12} className="formPadding">
                <CommonForm
                  formData={props.formData}
                  button={props.button}
                  onSubmittBtn={props.onSubmittBtn}
                  selectType={props.selectType}
                  handleClose={handleClose}
                  type={props.type}
                  defaultValues={props?.defaultValues}
                  optionData={props?.optionData}
                  onImageHandleChange={props?.onImageHandleChange}
                  formName={props?.formName}
                  onDependentFieldChange={props?.onDependentFieldChange}
                  enableSaveAsDraft={props?.enableSaveAsDraft}
                />
              </Grid>
            </Grid>

            {props.selectType === 'delete' ?
            <Box>
             <Grid container className="btnDialogContainer">
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="buttonSubmit"
                    type="submit"
                    fullWidth
                    onClick={() => {
                      props?.onConfirmDialog();
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
                <Grid item xs={5}>
                <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box> : null}
          </DialogContentText>

        </DialogContent>
      </Dialog>
    </div>
  );
}
